export var CategoryEnum;
(function (CategoryEnum) {
    CategoryEnum[CategoryEnum["NVL"] = 1] = "NVL";
    CategoryEnum[CategoryEnum["BP"] = 2] = "BP";
    CategoryEnum[CategoryEnum["TPHH"] = 3] = "TPHH";
    CategoryEnum[CategoryEnum["Other"] = 4] = "Other";
    CategoryEnum[CategoryEnum["CCDC"] = 5] = "CCDC";
    CategoryEnum[CategoryEnum["HR"] = 6] = "HR";
    CategoryEnum[CategoryEnum["SPHH"] = 7] = "SPHH";
    CategoryEnum[CategoryEnum["DV"] = 8] = "DV"; // Dịch vụ
})(CategoryEnum || (CategoryEnum = {}));
export var ItemMasterDataTabEnum;
(function (ItemMasterDataTabEnum) {
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["General"] = 1] = "General";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["Accounting"] = 2] = "Accounting";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["Production"] = 3] = "Production";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["WareHouse"] = 4] = "WareHouse";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["ResearchAndDevelopment"] = 5] = "ResearchAndDevelopment";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["Sell"] = 6] = "Sell";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["Purchase"] = 7] = "Purchase";
    ItemMasterDataTabEnum[ItemMasterDataTabEnum["Logistics"] = 8] = "Logistics";
})(ItemMasterDataTabEnum || (ItemMasterDataTabEnum = {}));
